import * as React from 'react'
function SvgLaunch(props) {
	return (
		<svg
			width="1em"
			height="1em"
			viewBox="0 0 40 40"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M11.822 27.4c1.422 1.422 1.422 3.556 0 4.978-1.422 1.422-6.044 1.066-6.044 1.066s-.356-4.8 1.066-6.044c1.423-1.422 3.556-1.422 4.978 0zM34.222 5c-.355 5.333-1.955 9.6-4.089 13.156 1.6 3.733.89 8.355-2.133 11.377-.533.711-1.244 1.245-1.956 1.6L21.6 26.69c-2.133 1.422-3.556 1.955-3.556 1.955l-7.288-7.288s.71-1.423 1.955-3.556l-4.444-4.444c.533-.712 1.066-1.423 1.6-1.956 3.022-3.2 7.466-3.911 11.2-2.133l.353-.237C24.752 6.847 29.073 5.343 34.222 5z"
				fill="currentColor"
				fillRule="evenodd"
			/>
		</svg>
	)
}
export default SvgLaunch
